export const blockIconsHomeNestSecureAlarmNew = (
	<span className='material-symbols-outlined'>nest_secure_alarm</span>
);
